
import { useConsumption } from '../../../hooks'

export default function LastConsumptionPresenter() {
    const {lastConsumptionQuery} = useConsumption()

    if (lastConsumptionQuery.isError) {
      return <>Error</>
    }

    if (lastConsumptionQuery.isLoading) {
      return <>...</>
    }
  return (
        <>{lastConsumptionQuery.data?.[0]?.Value || 'NA'}</>
  )
}
